import { TurnedIn } from "@material-ui/icons";
import { createSlice } from "@reduxjs/toolkit";

/**
 *
 * @type ClientSpocStoreClientSpoc
 */
const initialState = {
  clientSpocList: { loading: false, data: null, error: null },
   clientSpocGen: { loading: false, data: null, error: null },
  createclientSpoc: { loading: false, data: null, error: null },
  updateclientSpoc: { loading: false, data: null, error: null },
};

export const ClientSpocSlice = createSlice({
  name: "clientSpoc",
  initialState,
  reducers: {
     fetchClientSpocLeadGenRequest: (clientSpoc,action)=>{
      clientSpoc.clientSpocGen.loading = true;
      clientSpoc.clientSpocGen.error = null;    
        },
        fetchClientSpocLeadGenSuccess: (clientSpoc,action)=>{
          clientSpoc.clientSpocGen.data = action.payload;
          clientSpoc.clientSpocGen.loading = true;
          clientSpoc.clientSpocGen.error = null; 
         },
         fetchClientSpocLeadGenFailure: (clientSpoc,action)=>{
          clientSpoc.clientSpocGen.data = null;
          clientSpoc.clientSpocGen.loading = false;
          clientSpoc.clientSpocGen.error = action.payload;
         },
    fetchClientSpocListRequest: (clientSpoc, action) => {
      clientSpoc.clientSpocList.loading = true;
      clientSpoc.clientSpocList.error = null;
    },
    fetchClientSpocListSuccess: (clientSpoc, action) => {
      clientSpoc.clientSpocList.data = action.payload;
      clientSpoc.clientSpocList.loading = false;
      clientSpoc.clientSpocList.error = null;
    },
    fetchClientSpocListFailure: (clientSpoc, action) => {
      clientSpoc.clientSpocList.data = null;
      clientSpoc.clientSpocList.loading = false;
      clientSpoc.clientSpocList.error = action.payload;
    },
    createclientSpocRequest: (clientSpoc, action) => {
      clientSpoc.createclientSpoc.loading = true;
      clientSpoc.createclientSpoc.error = null;
    },
    createclientSpocSuccess: (clientSpoc, action) => {
      clientSpoc.createclientSpoc.data = action.payload;
      clientSpoc.createclientSpoc.loading = false;
      clientSpoc.createclientSpoc.error = null;
      clientSpoc.clientSpocList = addNewclientSpocSuccess(action.payload, {
        ...clientSpoc.clientSpocList,
      });
    },
    createclientSpocFailure: (clientSpoc, action) => {
      clientSpoc.createclientSpoc.data = null;
      clientSpoc.createclientSpoc.loading = false;
      clientSpoc.createclientSpoc.error = action.payload;
    },
    updateclientSpocRequest: (clientSpoc, action) => {
      clientSpoc.updateclientSpoc.loading = true;
      clientSpoc.updateclientSpoc.error = null;
    },
    updateclientSpocSuccess: (clientSpoc, action) => {
      clientSpoc.updateclientSpoc.data = action.payload;
      clientSpoc.updateclientSpoc.loading = false;
      clientSpoc.updateclientSpoc.error = null;
      clientSpoc.clientSpocList = updateclientSpocListSuccess(action.payload, {
        ...clientSpoc.clientSpocList,
      });
    },
    updateclientSpocFaliure: (clientSpoc, action) => {
      clientSpoc.updateclientSpoc.data = null;
      clientSpoc.updateclientSpoc.loading = false;
      clientSpoc.updateclientSpoc.error = action.payload;
    },
    resetClientSpoc: (data, action) => {
      data.createclientSpoc.data = null;
      data.createclientSpoc.error = null;
      data.createclientSpoc.loading = false;

      data.updateclientSpoc.data = null;
      data.updateclientSpoc.error = null;
      data.updateclientSpoc.loading = false;
    },
  },
});
function addNewclientSpocSuccess(dataToUpdate, state) {
  if (state.data !== null) {
    state.data.data = [dataToUpdate, ...state.data.data];
    state.data.total++;
  }
  return state;
}
function updateclientSpocListSuccess(dataToUpdate, state) {
  state.data.data = state.data.data.map((lead) => {
       if (lead._id !== dataToUpdate._id) return lead;
    return { ...lead, ...dataToUpdate };
  });

  return state;
}

export const {
  fetchClientSpocListRequest,
  fetchClientSpocListSuccess,
  fetchClientSpocListFailure,
  fetchClientSpocLeadGenFailure,
  fetchClientSpocLeadGenSuccess,
  fetchClientSpocLeadGenRequest,
  createclientSpocRequest,
  createclientSpocSuccess,
  createclientSpocFailure,
  updateclientSpocRequest,
  updateclientSpocSuccess,
  updateclientSpocFaliure,
  resetClientSpoc,
} = ClientSpocSlice.actions;

/**
 *
 * @param {*} store
 * @returns {ClientSpocStoreClientSpoc['clientSpocList']}
 */
export const getClientSpocListState = (store) =>
  store.clientSpoc?.clientSpocList;
export const getClientSpocCreateState = (store) =>
  store.clientSpoc?.createclientSpoc;
  export const getClientListStateGen =(store)=>
  store.clientSpoc?.clientSpocGen;
  export const getClientSpocUpdateState = (store) =>
    store.clientSpoc?.updateclientSpoc;
export default ClientSpocSlice.reducer;
